export default function moveToTopOfPage () {
  window.scrollTo({ top: 0, behavior: "instant" });
}
